export const blockIconsTextformattingGridViewNew = (
	<span className='material-symbols-outlined'>grid_view</span>
);
